export enum UserType {    
    SystemAdmin = 0,
    Teacher = 1,
    Student = 2
}